module.exports = __webpack_public_path__ + "static/1-2a2d3c046e31f8095111bf86f368ec8a.png";